import styles from './styles.module.scss';
import { FunctionComponent, useMemo } from 'react';
import classNames from 'classnames';
import { renderPrice } from '../../../../../services/renderPrice';

export type PriceSummaryProps = {
    label: string;
    price: number;
    currency: string;
    className?: string;
};

export const PriceSummary: FunctionComponent<PriceSummaryProps> = ({
    label,
    price,
    currency,
    className,
}) => {
    const formattedPrice = useMemo(() => {
        if (isNaN(price)) {
            return '';
        }
        return renderPrice(price, currency);
    }, [price, currency]);
    return (
        <p className={classNames(styles.priceSummary, className)}>
            <span>{label}</span>
            <span>{formattedPrice}</span>
        </p>
    );
};
